import { useState, useCallback } from 'react';
import { askChapter } from '../api/chapterAsk';
import type { ChapterAskRequest, ChapterAskResponse } from '../api/chapterAsk';

export interface UseChapterAskReturn {
  loading: boolean;
  error: string | null;
  ask: (chapterId: number, question: string) => Promise<ChapterAskResponse>;
}

export const useChapterAsk = (): UseChapterAskReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const ask = useCallback(async (chapterId: number, question: string): Promise<ChapterAskResponse> => {
    if (!question.trim()) {
      throw new Error('سوال نمی‌تواند خالی باشد');
    }

    try {
      setLoading(true);
      setError(null);
      
      const payload: ChapterAskRequest = { question: question.trim() };
      const response: ChapterAskResponse = await askChapter(chapterId, payload);
      
      return response;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'خطا در ارسال سوال';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    ask,
  };
};
